import React, { useEffect, useState } from 'react'
import { Layer, Button } from 'components'
import Lib from 'library'
import useApp from 'hooks/useApp'
import 'suneditor/dist/css/suneditor.min.css'

const TermsLayer = ({ show, closeLayer, title, content, buttonText = "동의", onButton, termsCd }) => {

	const App = useApp()
	const [terms, setTerms] = useState()

	useEffect(() => {
		if (!content && termsCd) {
			Lib.get(`/api/comm/terms/${termsCd}`, data => {
				setTerms(data)
			})
		}
	}, [show])

	return (
		<Layer show={show} closeLayer={closeLayer} title={title ? title : terms?.termsNm}>
			<div className="px_10 flex-column" style={{ minHeight: "100%" }}>
				<p className="agreementP" style={{ textAlign: "justify", lineHeight: 1.7 }}>
					{
						content ? <div className="sun-editor-editable" dangerouslySetInnerHTML={{ __html: content }} />
							:
							<div className="sun-editor-editable" dangerouslySetInnerHTML={{ __html: terms?.termsConts }} />
					}

				</p>
				<div className="pb_20">
					<Button className="w_100 flex-shrink_0" onClick={onButton}>{buttonText}</Button>
				</div>
			</div>
		</Layer>
	)
}

export default TermsLayer
